export default __webpack_public_path__ + "static/media/categories.ce971833.svg";